import React from 'react'

import PageLayout from '@/CandidateExperience/components/PageLayout'
import SubNav from '@/Jobs/components/SubNav'
import RecommendedJobsList from '@/Jobs/components/RecommendedJobsList'

const JobsListScene = () => {
  return <PageLayout toolbarContent={<SubNav />} body={<RecommendedJobsList />} />
}

export default JobsListScene
